<script lang="ts">
    import {Icon, Block, Card, CardContent, Link, CardFooter, f7, Page} from 'framework7-svelte';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { navparts } from '../utils/navparts';
    import Header from '../components/Header.svelte';
    import { user } from '../auth/user';
    import { logout, login } from '../utils/credentials';
    import type {AppPage} from "../types/app-page.type";
    import {importTokenStore} from "../stores/import-token.store";

    onMount(() => {
        navparts.set([]);
    });

    let allpages: AppPage[] = [];

    $: allpages = deriveAllPages($user, $_);

    function isAdmin(user) {
        const userProfile = user["profile"];
        if(userProfile === null || userProfile === undefined)
            return false;

        return userProfile["realm_access"]?.roles.includes("admin")
    }

    function deriveAllPages(user, translate) {
        const pages = [];

        const projectsPage: AppPage = {
            name: translate('shared.PROJECTS'),
            href: '/projects',
            icon: 'pin',
            callback: () => { }
        };

        const loginPage: AppPage = {
            name: translate('shared.LOGIN'),
            icon: 'person_circle',
            login: true,
            callback: () => login()
        };

        const logoutPage: AppPage = {
            name: translate('shared.LOGOUT'),
            icon: 'person_circle',
            login: true,
            callback: () => logout()
        };

        const importPage: AppPage = {
            name: translate('shared.IMPORT'),
            icon: 'pin',
            callback: () => {
                if($importTokenStore != null) {
                    f7.views.main.router.navigate('/import');
                    return;
                }
            }
        };

        if (user) {
            pages.push(projectsPage);
            if(isAdmin(user))
                pages.push(importPage);

            pages.push(logoutPage);
        }

        if (!user) {
            pages.push(loginPage);
        }

        return pages;
    }

    function getLoginScreenIfNotLoggedIn(page: AppPage): string | undefined {
        if(page.name !== $_('shared.IMPORT')) return undefined;
        if($importTokenStore == null) return '#login-screen';

        return undefined;
    }
</script>

<Page>
    <Header />
    <Block>
        {#each allpages as page}
            <Link href={page.href} on:click={() => page.callback(page)} loginScreenOpen="{getLoginScreenIfNotLoggedIn(page)}" class="main-page-link">
                <Card class="main-page-square">
                    <CardContent>
                        <div class="text-align-center">
                            <Icon f7={page.icon} size="200"></Icon>
                        </div>
                    </CardContent>
                    <CardFooter>
                        <div class="text-align-center" style="width: 100%">
                            {page.name}
                        </div>
                    </CardFooter>
                </Card>
            </Link>
        {/each}
    </Block>
</Page>

<style lang="scss">
    :global(.main-page-square) {
        width: 350px;
        height: 300px;
        margin: 2rem;
        display: inline-block;
    }
</style>
